import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
} from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';

@Directive({
  selector: '[appTableRowMovement]',
})
export class TableRowMovementDirective implements OnInit, OnDestroy {
  @Output() onEnterEvent: EventEmitter<void> = new EventEmitter<void>();
  @Output() onEscape: EventEmitter<void> = new EventEmitter<void>();

  pageRef: ElementRef;
  @Input() selectedIndex: BehaviorSubject<number>;
  @Input() dataSource$: Observable<any[]>;
  @Input() disabled$: Observable<boolean>;

  private subscriptions = new Subscription();
  private waiting: boolean;
  private data: any[];
  private disabled: boolean;

  constructor(
    el: ElementRef,
    private renderer: Renderer2
  ) {
    this.pageRef = el;
  }

  ngOnInit(): void {
    if (this.dataSource$) {
      this.subscriptions.add(
        this.dataSource$.subscribe((data) => {
          this.data = data;
          // console.log('this.data', this.data);
        })
      );
    }
    if (this.disabled$) {
      this.subscriptions.add(
        this.disabled$.subscribe((value) => {
          this.disabled = value;
        })
      );
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  /**
   * Handle arrow down event.
   *
   * @param event
   */
  @HostListener('document:keydown.arrowdown', ['$event']) onArrowDown(
    event: KeyboardEvent
  ) {
    if (this.disabled || this.pageRef.nativeElement.offsetParent === null) {
      return;
    }

    event.preventDefault();

    if (this.data.length > this.selectedIndex.getValue() + 1) {
      this.selectedIndex.next(this.selectedIndex.getValue() + 1);
      this.scrollToElement();
    }
  }

  /**
   * Handle arrow up event.
   *
   * @param event
   */
  @HostListener('document:keydown.arrowup', ['$event']) onArrowUp(
    event: KeyboardEvent
  ) {
    if (this.disabled || this.pageRef.nativeElement.offsetParent === null) {
      return;
    }

    event.preventDefault();

    if (this.selectedIndex.getValue() > 0) {
      this.selectedIndex.next(this.selectedIndex.getValue() - 1);
      this.scrollToElement();
    }
  }

  /**
   * Handle enter event.
   *
   * @param event
   */
  @HostListener('document:keydown.enter', ['$event']) onEnter(
    event: KeyboardEvent
  ) {
    if (this.disabled || this.pageRef.nativeElement.offsetParent === null) {
      return;
    }
    this.onEnterEvent.emit();
  }

  /**
   * Handle escape Key press. Cancel order selection.
   *
   * @param event
   */
  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(
    event: KeyboardEvent
  ) {
    if (this.disabled || this.pageRef.nativeElement.offsetParent === null) {
      return;
    }
    this.onEscape.emit();
  }

  private scrollToElement() {
    let index = 0;
    let list;

    if (this.pageRef.nativeElement.children[0].children[0].rows) {
      index = -1; // because in table the header is also a row.
      list = this.pageRef.nativeElement.children[0].children[0].rows;
    } else {
      list = this.pageRef.nativeElement.children[0].children;
    }

    for (const element of list) {
      this.renderer.setStyle(element, 'pointerEvents', 'none');
      if (index === this.selectedIndex.getValue()) {
        element.scrollIntoView(false);
      }
      index++;
    }

    if (!this.waiting) {
      setTimeout(() => {
        for (const element of list) {
          this.renderer.setStyle(element, 'pointerEvents', 'auto');
          this.waiting = false;
        }
      }, 500);
      this.waiting = true;
    }
  }
}
